<template>
	<Modal :title=title :closable='false' :mask-closable='false' :scrollable='true' :styles="{top:'20px'}" width="835" v-model="visiable">
		<div id='content' v-html='content'>

		</div>

		<div class="bottom-button">
			<Button @click='confirm(false)' class='goon-btn' size='large' type='primary'>返回(back)</Button>
			<!-- <Button @click='confirm(true)' :disabled='countNum>0'  class='goon-btn'  size='large' type='primary'>{{countNum<=0?'同意(agree)':`同意(${countNum}秒)`}}</Button> -->
		</div>
		<div slot="footer" style='text-align: center;'>

		</div>
	</Modal>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
	data() {
		return {
			show: false,
			show1: false,
			title: "",
			isload: false,
			content: null,
			countNum: 10,
			timer: null
		};
	},
	props: {
		alertvalue: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ""
		},
		code: {
			type: String,
			default: ""
		}
	},
	watch: {
		alertvalue(val) {
			console.log("val", val);
			if (val) {
				this.open();
			}
			this.visiable = val;
		}
	},
	methods: {
		...mapActions(["getArticleDetailAction"]),
		confirm(result) {
			this.$emit("close");
		},
		
		remainingTime() {
			clearInterval(this.timer);
			this.timer = setInterval(() => {
				if (this.countNum <= 0) {
					clearInterval(this.timer);
				} else {
					this.countNum--;
				}
			}, 1000);
		}
	}
};
</script>
<style lang='scss'>
.agreement {
}
#content {
	margin-bottom: 30px;
}
.bottom-button {
	text-align: center;
}
.goon-btn {
	width: 40%;
	&.no {
		background-color: #dedede;
	}
}
@media screen and (max-width: 768px) {
	.ivu-modal-wrap {
		position: fixed;
		z-index: 1001;
	}
	.ivu-modal-mask {
		position: fixed;
		z-index: 1000;
	}
}
</style>